import { User } from '../types';

export type TesterLevel = 'none' | 'internal' | 'beta';

export const TESTER_OPTIONS: { value: TesterLevel; label: string }[] = [
  { value: 'none', label: 'None' },
  { value: 'internal', label: 'Internal' },
  { value: 'beta', label: 'Beta' },
];

export const TESTER_UNREAD_EVENT = 'fluora-tester-unread-changed';

export function resolveTester(user: Pick<User, 'tester' | 'isBetaTester' | 'isBetaTest' | 'betaProgram'>): TesterLevel {
  if (user.tester === 'internal' || user.tester === 'beta' || user.tester === 'none') {
    return user.tester;
  }
  return user.isBetaTester || user.isBetaTest || user.betaProgram ? 'beta' : 'none';
}

export function notifyTesterUnreadChanged() {
  window.dispatchEvent(new CustomEvent(TESTER_UNREAD_EVENT));
}

export function testerSelectClass(tester: TesterLevel) {
  if (tester === 'internal') {
    return 'tester-select tester-select-internal';
  }
  if (tester === 'beta') {
    return 'tester-select tester-select-beta';
  }
  return 'tester-select';
}

export function testerBadgeClass(tester: TesterLevel) {
  if (tester === 'internal') {
    return 'bg-warning';
  }
  if (tester === 'beta') {
    return 'bg-primary';
  }
  return 'bg-secondary';
}

export function testerLabel(tester: TesterLevel) {
  return TESTER_OPTIONS.find((option) => option.value === tester)?.label ?? 'None';
}
